import { MagnifyingGlassIcon } from '@heroicons/react/24/solid';
import type { MultiSelectProps } from '@mantine/core';
import { MultiSelect } from '@mantine/core';
import React from 'react';

import styles from './SearchMultiselect.module.css';

export const LBSearchMultiselect = React.forwardRef<
  React.ElementRef<typeof MultiSelect>,
  Omit<MultiSelectProps, 'label' | 'description' | 'error' | 'withAsterisk	'>
>((props, ref) => (
  <MultiSelect
    {...props}
    ref={ref}
    withCheckIcon
    classNames={styles}
    rightSection={<MagnifyingGlassIcon height={18} width={18} />}
  />
));
